import { atom } from "recoil";
import { IExpenseAccount } from "../type";

export const addStateExpenseAccount = atom({
  key: "addStateExpenseAccount",
  default: false,
});
export const editStateExpenseAccount = atom({
  key: "editStateExpenseAccount",
  default: false,
});
export const rowEditExpenseAccount = atom<IExpenseAccount | undefined>({
  key: "rowEditExpenseAccount",
  default: undefined,
});

export const selectedRowsStateExpenseAccount = atom<IExpenseAccount[]>({
  key: "selectedRowsStateExpenseAccount",
  default: [],
});

export const expenseAccountFilterText = atom({
  key: "expenseAccountFilterText",
  default: "",
});

export const expenseAccountFetching = atom({
  key: "expenseAccountFetching",
  default: true,
});
export const expenseAccountReFetching = atom({
  key: "expenseAccountReFetching",
  default: false,
});
